'use client'; // NextJS 13 requires this. Remove if you are using NextJS 12 or lower

import { useEffect } from 'react';
import Script from 'next/script';
import { SessionType } from '@/util/types/globalTypes';

const FeaturebaseSDK = ({ session }: { session: SessionType }) => {
  // console.log(session);
  useEffect(() => {
    if (!session) return;
    const win = window as any;
    if (typeof win.Featurebase !== 'function') {
      win.Featurebase = function () {
        // eslint-disable-next-line prefer-rest-params
        (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
      };
    }

    const isValidUrl = (url?: string | null) => {
      if (!url) return false;
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    };

    const profilePictureUrl =
      session.user.employee?.thumb || session.user.picture;

    const authBody = {
      // Required. Replace with your customers data.
      email: session.user.email,
      name: `${session.user.firstName} ${session.user.lastName}`,
      id: session.user._id,
      organization: 'attik',
      ...(isValidUrl(profilePictureUrl)
        ? { profilePicture: profilePictureUrl }
        : {}),
      companies: [
        {
          id: session.user.company._id, // required
          name: session.user.company.name, // required
        },
      ],
    };

    // console.log('session', session);

    win.Featurebase('identify', authBody, (err: any, response: any) => {
      // Callback function. Called when identify completed.
      // console.log('Featurebase: identify response', response);
      if (err) {
        console.error(err);
      } else {
        console.log('Featurebase: user linked successfully!');
      }
    });

    // win.Featurebase(
    //   'embed',
    //   {
    //     organization: 'attik',
    //     // Rest of the params
    //   },
    //   (err: any, callback: any) => {
    //     console.log('Featurebase: embed callback', callback);
    //     // Check for callback.action to listen for events above
    //     if (callback?.action === 'widgetReady') {
    //       // Do something
    //     }
    //   }
    // );

    win.Featurebase('init_changelog_widget', {
      organization: 'attik', // Replace this with your organization name, copy-paste the subdomain part from your Featurebase workspace url (e.g. https://*yourorg*.featurebase.app)
      dropdown: {
        enabled: true, // Add this to enable the dropdown view of the changelog
        placement: 'right', // Add this to change the placement of the dropdown
      },
      popup: {
        enabled: true, // Add this to enable the popup view of the changelog
        usersName: session.user.firstName || '', // This will show the user's name in the popup as a greeting
        autoOpenForNewUpdates: true, // This will open the popup for new updates
      },
      theme: 'light', // Choose between dark or light theme
      locale: 'en', // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
    });

    // win.Featurebase('initialize_feedback_widget', {
    //   organization: 'attik', // Replace this with your organization name, copy-paste the subdomain part from your Featurebase workspace url (e.g. https://*yourorg*.featurebase.app)
    //   theme: 'light',
    //   locale: 'en', // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
    //   // placement: 'right', // optional - remove to hide the floating button
    //   // email: "youruser@example.com", // optional
    //   // defaultBoard: "yourboardname", // optional - preselect a board
    //   metadata: null, // Attach session-specific metadata to feedback. Refer to the advanced section for the details: https://help.featurebase.app/en/articles/3774671-advanced#7k8iriyap66
    // });

    /*
     * Removing the chatbox for now in favor of g chat.
     * Retaining the changelog widget for now.
     * 6/1/2026
    */
    // win.Featurebase('boot', {
    //   appId: '67a306265b865569a123326a', // required
    //   email: session.user.email, // optional
    //   userId: session.user._id, // optional (will be stringified)
    //   createdAt: session.user.createdAt, // optional
    //   theme: 'light', // "light" or "dark"
    //   language: 'en', // short code (e.g. "en", "de", etc.)
    //   hideDefaultLauncher: true,
    //   // session: session.user,
    //   // userHash: generatedToken         // Check the docs for additional details below
    //   // + feel free to add any more custom values about the user here
    //   // attikUserId: session.user._id,
    //   // attikCurrentMembership: session.user.membership._id,
    //   // attikCurrentCompany: session.user.company.name,
    //   // attikPermissions: session.user.membership.permissions,
    // });
  }, [session]);

  return (
    <>
      <Script
        src='https://do.featurebase.app/js/sdk.js'
        id='featurebase-sdk'
        strategy='afterInteractive'
      />
      {/* <div>
        <button data-featurebase-changelog>
          Open changelog <span id='fb-update-badge'></span>
        </button>
      </div> */}
    </>
  );
};

export default FeaturebaseSDK;
